<template>

    <div id="privacy">

        <div class="flex">
            <div class="flex-1 mb-4">
                <h1 class="text-2xl font-medium text-gray-900">Privacy Policy</h1>
            </div>

            <div class="flex mb-4 justify-end cursor-pointer">
                <router-link :to="{ name: 'app.index' }" custom v-slot="{ navigate }">
                    <button @click="navigate" class="btn">
                        Back to Application
                    </button>
                </router-link>
            </div>
        </div>

        <div class="panel">
            <div class="p-2 text-sm text-gray-600">
                <p>
                    MBL Solutions<br/>
                    Address: Valley Road, Birkenhead, Merseyside, England, CH41 7ED
                </p>

                <p>
                    We provide access to purchase gift cards from a number of retailers. As a result, we collect personal
                    data about you to provide our service, and we want to be clear and transparent as to what we do with
                    it.
                    If you have any questions about this privacy policy, including any requests to exercise your legal
                    rights, please contact us at operations@mblsolutions.co.uk
                </p>

                <h2>How do we use your data?</h2>

                <p>
                    When you sign up to MBL Solutions platforms we may collect your name, company details, phone number
                    and email address. We do this in order to perform our obligations under the contract we enter with
                    you and allow for you to use and access MBL Solutions applications.<br/>
                    When you request a demo, report or make an inquiry via our Platform we will collect your name,
                    company name, email address and contact number. We do this under our legitimate interest to respond
                    to your request quickly and efficiently.<br/>
                    When you contact us either by phone, email or via social media with general queries, we will usually
                    collect your name, and contact details, because it’s in our legitimate interest to make sure we can
                    properly respond to your query.<br/>
                    When you receive our news updates. We use your name and email address to provide you with our
                    updates in line with any preferences you’ve told us about.<br/>
                    If we send you our updates because you have opted-in to receive them, we rely on your consent to do
                    so. If you have not opted-in and we send you our updates, we do this because of our legitimate
                    interest to promote our business.<br/>
                    We do not collect or keep credit card data, we use a payment services provider. They store your data
                    and may enable us to make repeat payments on your card without us knowing any details - with your
                    permission of course.<br/>
                    You can unsubscribe at any time by clicking the unsubscribe link at the bottom of any of our emails,
                    or by emailing operations@mblsolutions.co.uk<br/>
                    Technical information may be shared when you use the MBL Solutions Platform. When you consent, we
                    collect information about how you use our Platform. We use this information to improve our Platform
                    and to better understand how people use it. More detail on this is set out in our cookie policy
                    below.<br/>
                    When you attend one of our events or a third party event we also attend, including virtual events
                    via video conferencing providers, we will usually collect your name, company details, phone number
                    and email address. At our own events we collect this information because it’s in our legitimate
                    interests to know who’s attending our events; and at third party events, we collect this information
                    because it is in our legitimate interests to promote our business.<br/>
                    If you apply for a job with us. When you enter into the recruitment process with us we may collect
                    your name, contact details, recruitment information and any additional information we may receive
                    from our recruitment partners. We may also undertake background screening checks. We do this in
                    order to take steps to enter into an employment contract with you and assess your suitability for a
                    role with us.<br/>
                    If our business is sold. We process your personal information for this purpose because we have a
                    legitimate interest to ensure our business can be continued by the buyer. If you object to our use
                    of your personal information in this way, the buyer of our business may not be able to provide
                    services to you.
                </p>

                <h2>Who do we share your data with?</h2>

                <ul>
                    <li>Business partners, suppliers and subcontractors where you have provided us with your consent to
                        do so including with our third party lead generation platform provider.
                    </li>
                    <li>Regulators/ Authorities/ Enforcement Agencies if we are under a duty to disclose or share your
                        personal data in order to comply with any legal obligation, or in order to enforce or apply our
                        terms of use and other agreements; or to protect the rights, property, or safety of our clients
                        or others. This includes exchanging information with other companies and organisations for the
                        purposes of fraud protection.
                    </li>
                    <li>Promotional events and marketing organisations, we do not sell data for marketing purposes, but
                        may share your data with an event organiser including where we run workshops with co-presenters.
                        We will always tell you before (usually on the event registration form) and you will be given
                        the chance to opt-out before we do this.
                    </li>
                    <li>Prospective buyers of our business under our legitimate interest to ensure our business can be
                        continued by the buyer.
                    </li>
                </ul>

                <h2>Where is my data stored?</h2>

                <p>
                    We store your data in the European Union, primarily in the UK and Republic of Ireland.
                </p>

                <h2>How long do we keep your data for?</h2>

                <p>
                    We will only retain your personal information for as long as we need it unless we are required to
                    keep it for longer to comply with our legal, accounting or regulatory requirements.<br/>
                    In some circumstances we may carefully anonymise your personal data so that it can no longer be
                    associated with you, and we may use this anonymised information indefinitely without notifying you.
                    We use this anonymised information to analyse our programmes.
                </p>


                <h2>What are your rights under data protection laws?</h2>

                <ul>
                    <li>Access your personal data (also known as a “subject access request”);</li>
                    <li>Correct incomplete or inaccurate data we hold about you;</li>
                    <li>Ask us to erase the personal data we hold about you;</li>
                    <li>Ask us to restrict our handling of your personal data;</li>
                    <li>Ask us to transfer your personal data to a third party;</li>
                    <li>Object to how we are using your personal data; and</li>
                    <li>Withdraw your consent to us handling your personal data.</li>
                </ul>

                <p>
                    You also have the right to lodge a complaint with your relevant supervisory authority. We will
                    always aim to comply with these requests unless there is a legal reason why we cannot do so.
                </p>

                <h2>Cookie Policy</h2>

                <p>
                    Our site uses cookies to distinguish you from other users of our site. This helps us to provide you
                    with a good experience when you browse our site and also allows us to improve our site. A cookie is
                    a small file of letters and numbers that we store on your browser or the hard drive of your
                    computer. We only use (and store) non-essential cookies on your computer's browser or hard drive if
                    you provide your consent. Our cookies do not store sensitive or personally identifiable information
                    such as credit card details.
                </p>

                <p>
                    You can block cookies by activating the setting on your browser that allows you to refuse the setting
                    of all or some cookies. However, if you use your browser settings to block all cookies (including
                    essential cookies) you may not be able to access all or parts of our site. We do not require consent
                    by law for strictly necessary cookies that provide services such as basket functionality.
                </p>

                <h2>Questions, Comments and More Detail</h2>

                <p>
                    Your feedback and suggestions on this can be sent to operations@mblsolutions.co.uk<br/>
                    Our Information Security Policy is available on request - If you require a copy, please email
                    operations@mblsolutions.co.uk<br/>
                    This privacy policy was last updated 20.08.2021.<br/>
                </p>

            </div>
        </div>

    </div>

</template>

<script>
export default {
    name: "Privacy"
}
</script>
